import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín López',
    age: '34 años',
    location: 'Buenos Aires, Argentina',
    quote: 'Antes tardaba dos días en escribir el copy de una landing. Con la skill #15 lo hice en 40 minutos y quedó mejor que lo que escribía a mano. Ya no vuelvo atrás.'
  }, {
    name: 'Camila Rojas',
    age: '28 años',
    location: 'Medellín, Colombia',
    quote: 'Lo que más me gustó es la skill de ángulos publicitarios. Sacaba 3-4 ideas de ads por semana, ahora genero 15 en una hora. Mis campañas mejoraron mucho.'
  }, {
    name: 'Santiago Herrera',
    age: '31 años',
    location: 'Santiago, Chile',
    quote: 'Tengo 3 ebooks en Hotmart y siempre me trababa en la parte de emails y ads. Con InfoSkills Pro armé la secuencia de lanzamiento completa en una tarde. Vendí más en ese launch que en los 3 anteriores juntos.'
  }, {
    name: 'Valentina Méndez',
    age: '26 años',
    location: 'Lima, Perú',
    quote: 'No sabía qué era Claude ni cómo usarlo. Pegué las instrucciones del bono y en 5 minutos tenía un asistente que entiende de infoproductos mejor que cualquier freelancer que contraté.'
  }, {
    name: 'Diego Aguirre',
    age: '37 años',
    location: 'Bogotá, Colombia',
    quote: 'La skill de métricas me salvó. Estaba gastando $200 USD por semana en ads sin entender por qué no vendía. El diagnóstico me dijo en 2 minutos que el problema era la landing, no los ads. Ajusté y empecé a vender al día siguiente.'
  }];
  return <section className="py-20 px-4" data-id="element-235">
      <div className="max-w-6xl mx-auto" data-id="element-236">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-237">
          Lo que dicen otros emprendedores
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-238">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-sm ${index === 3 ? 'lg:col-start-1 lg:col-span-1 lg:ml-auto' : ''} ${index === 4 ? 'lg:col-start-2 lg:col-span-2 lg:mr-auto lg:w-1/2' : ''}`} data-id="element-239">
              <div className="flex gap-1 mb-4" data-id="element-240">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#f1c40f] text-[#f1c40f]" data-id="element-241" />)}
              </div>
              <p className="text-gray-300 italic mb-6 leading-relaxed" data-id="element-242">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-243">
                <div className="w-12 h-12 bg-[#00B4D8] rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-244">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-245">
                  <p className="text-white font-bold" data-id="element-246">{testimonial.name}</p>
                  <p className="text-gray-400 text-sm" data-id="element-247">
                    {testimonial.age} | {testimonial.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}